/*
 * @Description: 机票数据存储
 * @Date: 2019-09-26 14:50:56
 * @LastEditTime: 2019-10-15 11:34:09
 */
import $req from '../lib/requests'
import $local from 'storejs'

//记录请求sessionId的时间
let recordTime = sessionStorage.getItem('sessionId.recordTime') || 0;

/**
 * 获取session_id
 */
function reqSessionId() {
    return new Promise((resolve, reject) => {
        $req.get("getcreate")
            .then(({ data }) => {
                if (data.code == 2000) {
                    resolve(data.data.session_id)
                }
            })
    })
}

/**
 * 获取机票热门城市推荐
 */
async function reqHotCity() {
    let { data } = await $req.get('v2_0_1/flightpopularcity')
    return data.code === '2000' ? data.data : []
}

const flight = {
    state: {
        sessionId: sessionStorage.getItem('session_id') || '',
        hotCitys: [],  //热门城市
        searchHistory: $local.get('flight.history') || []  //搜索历史记录
    },

    mutations: {
        SET_SESSION_ID: (state, id) => {
            sessionStorage.setItem('session_id', id)
            state.sessionId = id
        },
        SET_HOT_CITYS: (state, data) => {
            $local.set('flight.hotCity', data)
            state.hotCitys = data
        },
        SET_SEARCH_HISTORY: (state, data) => {
            $local.set("flight.history", data);
            state.searchHistory = data;
        }
    },

    actions: {
        async setSessionId({ commit }) {
            if (recordTime != 0 && (recordTime - Date.now()) <= 20 * 60 * 1000) {
                //请求过数据且请求时间在18分钟内
                return
            }

            await reqSessionId().then(sessionId => {
                recordTime = Date.now()
                sessionStorage.setItem('sessionId.recordTime', recordTime)
                commit('SET_SESSION_ID', sessionId)
            })
        },
        async setFlightHotCity({ commit }) {
            //如果存在热门数据，则不再请求
            // let cacheCity = $local.get('flight.hotCity')
            // if (cacheCity && cacheCity.length > 0) {
            //     return
            // }

            let hotCitys = await reqHotCity();

            commit('SET_HOT_CITYS', hotCitys)
        },
        setSearchHistory({ commit, state }, data) {
            let history = state.searchHistory;

            //为空或空数组的情况则清空所有数据
            if (!data || data.length === 0) {
                commit('SET_SEARCH_HISTORY', []);
                return
            }

            if (
                history.length < 5 &&
                !history.some(val => val.city_code === data.city_code)
            ) {
                //小于5个且不存在列表中则添加
                history.push(data);
            } else if (history.length >= 5 && !history.some(val => val.city_code === data.city_code)) {
                //大于5个
                history.shift();
                history.push(data);
            }

            commit('SET_SEARCH_HISTORY', history);
        }
    }
}

export default flight


// WEBPACK FOOTER //
// ./src/store/flight.js